import { Injectable } from '@angular/core';
import {
  calculateDeliveryCost,
  calculateParcelShippingCost,
} from '@pedix-workspace/shared-delivery';
import { ShippingCostRequest, ShippingCostResponse } from '@pedix-workspace/shared-delivery';

@Injectable({
  providedIn: 'root',
})
export class DeliveryService {
  async calculateShippingCost(
    shippingCostRequest: ShippingCostRequest,
  ): Promise<ShippingCostResponse | null> {
    if (
      shippingCostRequest.shippingOptionDelivery?.active &&
      shippingCostRequest.shippingOptionParcel?.active
    ) {
      const response = await calculateDeliveryCost(
        shippingCostRequest.shippingOptionDelivery,
        shippingCostRequest,
      );

      if (response?.outOfDeliveryZone) {
        return calculateParcelShippingCost(
          shippingCostRequest.shippingOptionParcel,
          shippingCostRequest,
        );
      }
      return response;
    }

    if (shippingCostRequest.shippingOptionDelivery?.active) {
      return calculateDeliveryCost(shippingCostRequest.shippingOptionDelivery, shippingCostRequest);
    }
    if (shippingCostRequest.shippingOptionParcel?.active) {
      return calculateParcelShippingCost(
        shippingCostRequest.shippingOptionParcel,
        shippingCostRequest,
      );
    }
    return null;
  }
}
